var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[_vm.currentRouteName, _vm.$mq]},[_c('SiteHeader',{staticClass:"site-h",class:_vm.$mq}),_c('router-view',{staticClass:"main-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }